import useGetStoreNewspaper from './useGetStoreNewspaper'

export default useGetStoreNewspaper
